module.exports = __webpack_public_path__ + "img/wood-vertical.d9c9ddce.jpg";